import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Header, Page } from 'components'
import { useSetorService } from 'hooks/useSetorService'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'
import useRouter from 'utils/useRouter'

import { Results } from './components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

export const Setores = (props) => {
  const { route } = props
  const router = useRouter()
  const classes = useStyles()
  const setorService = useSetorService()
  const [processando, setProcessando] = useState(false)
  const idsState = useSelector((state) => state.idsState)
  const setores = useSelector((state) => state.setores.setores)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  useEffect(() => {
    setorService.listarSetoresDeDivisaoGlobal(idsState.idDivisao, setProcessando)
    
  }, [])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header
        titulo={`${route.secao}`}
        overline={route.secao}
        textoBotao="Cadastrar novo"
        linkBotao={`${route.path}/cadastrar`}
        idPai={idsState.idDivisao}
      />
      {setores && <Results className={classes.results} dados={setores} processando={processando} />}
    </Page>
  )
}
